import styled from 'styled-components';

export const StyledOnboardingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(--white-main);
  z-index: 10000;
  overflow-y: auto;
`;

export const StyledOnboardingContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--big-padding);
  padding-block: var(--xlarge-padding) calc(var(--large-padding) * 4);
  padding-inline: var(--big-padding);
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: var(--big-padding) var(--default-padding);
  }
`;

export const StyledPill = styled.div`
  background: var(--red-dark-opacity);
  border-radius: var(--grand-border-radius);
  padding: var(--xxxsmall-padding) 9px;
  font-size: var(--xsmall-font-size);
  font-weight: 500;
  color: var(--red-darkest);
  text-align: center;
  line-height: 1.5;
  width: fit-content;
`;

export const StyledOnboardingTitle = styled.h1`
  font-size: 40px;
  font-weight: 700;
  line-height: 1.3;
  color: var(--black-main);
  margin: 0;

  @media (max-width: 768px) {
    font-size: var(--heading-large-font-size);
  }
`;

export const StyledOnboardingDescription = styled.p`
  font-size: var(--medium-font-size);
  line-height: 1.5;
  color: var(--black-main);
  margin: 0;
`;

export const StyledQuestionCard = styled.div`
  background: var(--beige-main);
  border-radius: var(--semi-medium-border-radius);
  padding: var(--semi-big-padding);
  width: 700px;
  max-width: 100%;
  display: flex;
  flex-direction: column;

  .quiz-progress-header {
    margin-bottom: 0;
  }
`;

export const StyledQuestionText = styled.p<{ isMultiChoice?: boolean }>`
  margin-block: ${({ isMultiChoice }) =>
    isMultiChoice
      ? 'var(--semi-big-padding) var(--default-padding)'
      : 'var(--semi-big-padding)'};
  font-size: var(--heading-small-font-size);
  line-height: 1.4;
  color: var(--black-main);
  font-weight: 400;
`;

export const StyledMultiChoiceText = styled.div`
  font-size: var(--xsmall-font-size);
  line-height: var(--xsmall-line-height);
  margin-bottom: var(--xxsmall-padding);
`;

export const StyledAnswerOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--small-padding);
`;

export const StyledAnswerOption = styled.label<{ $isSelected?: boolean }>`
  display: flex;
  align-items: center;
  gap: var(--xsmall-padding);
  padding: var(--small-border-radius);
  background: var(--white-main);
  border-radius: var(--xsmall-border-radius);
  cursor: pointer;
  font-size: var(--medium-font-size);
  line-height: 1.4;
  color: var(--black-main);
  font-weight: 400;
  transition: background 0.15s ease;

  &:hover {
    background: var(--gray-pale);
  }

  .p-radiobutton {
    width: 24px !important;
    height: 24px !important;
    flex-shrink: 0;
    padding: 0;

    .p-radiobutton-box,
    .p-checkbox-box {
      width: 100% !important;
      height: 100% !important;
      border-radius: 12px;
      border: 1.333px solid var(--gray-dark);
      background: var(--white-main);
      box-shadow: none !important;
      transition: border 0.15s ease;

      .p-radiobutton-icon,
      .p-checkbox-icon {
        display: none !important;
      }

      &.p-highlight {
        border: 7px solid var(--red-main);
        background: var(--white-main);
        box-shadow: none !important;
      }

      &:not(.p-disabled):not(.p-highlight):hover {
        border-color: var(--gray-neutral);
      }
    }
  }
`;

export const StyledSuccessImage = styled.div`
  width: 278px;
  height: 278px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const StyledCustomInputTextarea = styled.textarea`
  width: 100%;
  height: 127px;
  border-radius: var(--small-border-radius);
  border: 1px solid var(--gray-moderate);
  padding: var(--medium-padding);
  font-size: var(--small-font-size);
  margin-top: var(--xsmall-padding);
  resize: none;
  background-color: var(--white-main);
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: var(--red-main);
    box-shadow: var(--box-shadow-red-no-blur);
  }
`;

export const StyledWatermark = styled.div`
  position: absolute;
  bottom: -90px;
  left: 50%;
  transform: translateX(-50%);
  font-size: clamp(200px, 19vw, 350px);
  font-weight: 900;
  color: rgba(0, 0, 0, 0.04);
  white-space: nowrap;
  pointer-events: none;
  user-select: none;
  letter-spacing: -4px;
  line-height: 1;
`;

export const StyledQuestionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--xsmall-padding);
  text-align: center;
  width: 100%;
  max-width: 613px;
`;

export const StyledQuestionHeaderTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--medium-big-padding);
  text-align: center;
`;

export const StyledQuestionButtonArea = styled.div`
  display: flex;
  align-items: center;
  gap: var(--default-padding);
`;
